import { render } from "./Program.vue?vue&type=template&id=4c571003&scoped=true&ts=true"
import script from "./Program.vue?vue&type=script&lang=ts"
export * from "./Program.vue?vue&type=script&lang=ts"

import "./Program.vue?vue&type=style&index=0&id=4c571003&scoped=true&lang=scss"
import "./Program.vue?vue&type=style&index=1&id=4c571003&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c571003"]])

export default __exports__